// Overview Metrics Grid Component
// Displays the 6 main metrics at the top of the analytics page

import { Users, Target, Activity, TrendingUp, BarChart3 } from 'lucide-react';
import MetricCard from './MetricCard';

const OverviewMetrics = ({ overview }) => {
  if (!overview) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4" data-testid="overview-metrics">
      <MetricCard
        title="Total Leads"
        value={overview.metrics.total_leads.value}
        previousValue={overview.metrics.total_leads.previous}
        change={overview.metrics.total_leads.change}
        icon={Users}
      />
      <MetricCard
        title="Viable Leads"
        value={overview.metrics.viable_leads.value}
        previousValue={overview.metrics.viable_leads.previous}
        change={overview.metrics.viable_leads.change}
        icon={Target}
      />
      <MetricCard
        title="Contacted"
        value={overview.metrics.contacted.value}
        previousValue={overview.metrics.contacted.previous}
        change={overview.metrics.contacted.change}
        icon={Activity}
      />
      <MetricCard
        title="Converted"
        value={overview.metrics.converted.value}
        previousValue={overview.metrics.converted.previous}
        change={overview.metrics.converted.change}
        icon={TrendingUp}
      />
      <MetricCard
        title="Conversion Rate"
        value={overview.metrics.conversion_rate.value}
        previousValue={overview.metrics.conversion_rate.previous}
        change={overview.metrics.conversion_rate.change}
        suffix="%"
        icon={BarChart3}
      />
      <MetricCard
        title="Avg Lead Score"
        value={overview.metrics.avg_lead_score.value}
        previousValue={overview.metrics.avg_lead_score.previous}
        change={overview.metrics.avg_lead_score.change}
        icon={Target}
      />
    </div>
  );
};

export default OverviewMetrics;
